import React from 'react';
import * as _ from 'lodash';
import { gql, useQuery } from '@apollo/client';

import OverviewMap from './Overview/OverviewMap';
import { Overview_ListingData } from '../types/graph/Overview_ListingData';
import Stats from './Overview/Stats';

const Overview: React.FC = () => {
  const { data, loading, error } =
    useQuery<Overview_ListingData>(LISTINGS_QUERY);

  if (error) {
    console.error(error);
  }

  if (loading || !data || !data.listings) {
    return <div>Loading...</div>;
  }

  return (
    <div className="overflow-hidden">
      <div className="flex flex-col space-y-8">
        <Stats />
        <OverviewMap listings={_.get(data, 'listings', false) || []} />
      </div>
    </div>
  );
};

export default Overview;

const LISTINGS_QUERY = gql`
  query Overview_ListingData {
    listings {
      id
      property {
        address {
          street
          city
          region
          country
          lat
          lng
        }
      }
    }
  }
`;
